export class GdsgWorkerHeartbeatStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "requestedWorkers",
            "baseName": "requestedWorkers",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "observedWorkers",
            "baseName": "observedWorkers",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "worstHeartbeatAtMs",
            "baseName": "worstHeartbeatAtMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "worstHeartbeatAgeMs",
            "baseName": "worstHeartbeatAgeMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "drainingWorkers",
            "baseName": "drainingWorkers",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "drainRequestedWorkers",
            "baseName": "drainRequestedWorkers",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgWorkerHeartbeatStats.attributeTypeMap;
    }
    constructor() {
    }
}
